import { render, staticRenderFns } from "./AlarmSetting.vue?vue&type=template&id=79f341aa&"
import script from "./AlarmSetting.vue?vue&type=script&lang=js&"
export * from "./AlarmSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports